import { createContext, useContext } from 'react';
import type { ShopperSearch } from '@/scapi';

export type LoginDrawerRequest = {
    returnUrl?: string;
    action?: string;
    actionParams?: string;
};

export type WishlistSelectionRequest = {
    product: ShopperSearch.schemas['ProductSearchHit'];
    variant?: ShopperSearch.schemas['ProductSearchHit'];
};

export type WishlistBulkSaveRequest = {
    productIds: string[];
};

export type WishlistOverlayTrigger = {
    id: string;
    element: HTMLElement;
};

export type WishlistOverlayContextValue = {
    openLoginDrawer: (request: LoginDrawerRequest) => void;
    openWishlistSelectionDrawer: (request: WishlistSelectionRequest) => void;
    openWishlistBulkSaveDrawer: (request: WishlistBulkSaveRequest) => void;
    /** Registers the control that opens the next overlay so it gets `aria-expanded` and focus back on close. */
    setOverlayTrigger: (trigger: WishlistOverlayTrigger) => void;
    activeTriggerId?: string;
    /** Id of the login or wishlist selection drawer currently open, if any. */
    openOverlayId?: string;
};

export const WishlistOverlayContext = createContext<WishlistOverlayContextValue | null>(null);

export function useWishlistOverlay(): WishlistOverlayContextValue {
    const context = useContext(WishlistOverlayContext);
    if (!context) {
        throw new Error('useWishlistOverlay must be used within WishlistOverlayProvider');
    }
    return context;
}

/** Returns null outside WishlistOverlayProvider (e.g. PDP uses toast-only auth). */
export function useOptionalWishlistOverlay(): WishlistOverlayContextValue | null {
    return useContext(WishlistOverlayContext);
}
